/* eslint-disable prettier/prettier */
export const visualSourcesDictionary = {
    'seemore-boxes-animation': 'assets/animations/seemore-boxes-animation.json',
    'seemore-working-animation': 'assets/animations/seemore-working-animation.json',
    'empty-box': 'assets/img/empty-box.png',
    'illustrations-big': 'assets/img/illustrations-big.svg',
    'illustration-ghost': 'assets/img/illustration-ghost.svg',
    'seemore-full-success': 'assets/img/seemore-full-success.svg',
    'seemore-empty-state': 'assets/img/seemore_empty_state.svg',
    seemore_swinging: 'assets/img/seemore_swinging.svg',
    'seemore-sad': 'assets/img/seemore-sad.svg',
    'seemore-run-automation-success': 'assets/img/seemore-run-automation-success.svg',
    seemore_in_crossroad: 'assets/img/seemore_in_crossroad.svg',
    seemore_in_crossroad_small: 'assets/img/seemore_in_crossroad_small.svg',
    request_status_empty_state: 'assets/img/request_status_empty_state.svg',
    'seemore-like': 'assets/img/seemore-like.svg',
    'ghost-failure': 'assets/img/ghost-failure.svg',
    text: 'assets/img/text.svg',
    'bell--black': 'assets/icons/svgs/bell--black.svg',
    'broken-link': 'assets/icons/svgs/broken-link.svg',
    'check-circle': 'assets/icons/svgs/check-circle.svg',
    icons_custom_click: 'assets/icons/svgs/icons_custom_click.svg',
    'seemore-sad-1': 'assets/icons/svgs/seemore-sad-1.svg',
    'seemore-illustration': 'assets/icons/svgs/seemore-illustration.svg'
} as const;

export type EmptyStateVisualSource = keyof typeof visualSourcesDictionary;
